var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;fill-rule:evenodd;}")),React.createElement("path",{"className":"cls-1","d":"M11.83,9.92v0l0,0Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M20.32,0H1.68A1.6,1.6,0,0,0,.07,1.58V20.42A1.6,1.6,0,0,0,1.68,22H20.32a1.6,1.6,0,0,0,1.61-1.58V1.58A1.6,1.6,0,0,0,20.32,0ZM6.7,18.42H3.39V8.48H6.7ZM5.05,7.13H5a1.72,1.72,0,1,1,.05-3.44,1.72,1.72,0,1,1,0,3.44ZM18.6,18.42H15.3V13.1c0-1.33-.48-2.24-1.67-2.24a1.82,1.82,0,0,0-1.7,1.2,2.5,2.5,0,0,0-.1.81v5.55H8.52s.05-9,0-9.94h3.31V9.89a3.25,3.25,0,0,1,3-1.64c2.17,0,3.8,1.42,3.8,4.47Z","key":2})]);
}

SocialLinkedin.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 22 22"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
